import { render, staticRenderFns } from "./VirHomePart7.vue?vue&type=template&id=6dc868cb&scoped=true&"
import script from "./VirHomePart7.vue?vue&type=script&lang=js&"
export * from "./VirHomePart7.vue?vue&type=script&lang=js&"
import style0 from "./VirHomePart7.vue?vue&type=style&index=0&id=6dc868cb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc868cb",
  null
  
)

export default component.exports